var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRadioDisalbedUnchecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Radio Button"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 112",
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#F1F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12.0016 22.0031C17.5253 22.0031 22.0031 17.5253 22.0031 12.0016C22.0031 6.47785 17.5253 2 12.0016 2C6.47785 2 2 6.47785 2 12.0016C2 17.5253 6.47785 22.0031 12.0016 22.0031ZM12.0016 20.5031C7.30627 20.5031 3.5 16.6968 3.5 12.0016C3.5 7.30627 7.30627 3.5 12.0016 3.5C16.6968 3.5 20.5031 7.30627 20.5031 12.0016C20.5031 16.6968 16.6968 20.5031 12.0016 20.5031Z",
    fill: "#CFD6D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRadioDisalbedUnchecked);
export default __webpack_public_path__ + "static/media/icon-radio-disalbed-unchecked.60e6efa0b2473e72e1a8c1d506a275e5.svg";
export { ForwardRef as ReactComponent };